export const FSConfig = {
  stripePublicationKey: process.env.REACT_APP_STRIPE_PUBLISH_KEY,
  smartboardUrl: process.env.REACT_APP_SMARTBOARD_URL,
  radarGeoAPI: process.env.REACT_APP_RADAR_GEO_API,
};